import { ExportOutlined } from "@ant-design/icons";
import { Popover, Typography } from "antd";
import { ReactElement } from "react";

export const LogoImage = (args: {
  logo: ReactElement | string;
  size?: number;
  title: string;
}) => {
  const { logo, size, title } = args;
  return typeof logo === "string" ? (
    <img src={logo} alt={`${title} logo`} width={size ?? 20} />
  ) : (
    logo
  );
};

export const Logo: React.FC<{
  logo: ReactElement | string;
  size?: number;
  title: string;
  trademark?: {
    notice: string;
    url: string;
  };
}> = (props) => {
  const { trademark } = props;
  return trademark ? (
    <Popover
      trigger="hover"
      content={
        <>
          <Typography.Text>{trademark.notice}</Typography.Text>
          &nbsp;
          <Typography.Link href={trademark.url} target="_blank" rel="noopener">
            <ExportOutlined />
          </Typography.Link>
        </>
      }
      placement="top"
    >
      {LogoImage(props)}
    </Popover>
  ) : (
    LogoImage(props)
  );
};
